export const iconFontAwesomeMovingWineGlass = (
	<i className="fa-solid fa-wine-glass"></i>
);
